import React, { useEffect } from "react";
import "./ScrollImg.css";

import c1 from "../../Assets/project17/c1.webp";
import c2 from "../../Assets/project17/c2.webp";
import c3 from "../../Assets/project17/c3.webp";
import c4 from "../../Assets/project17/c4.webp";
import c5 from "../../Assets/project17/c5.webp";
import c6 from "../../Assets/project17/c6.webp";
import c7 from "../../Assets/project17/c7.webp";


const ScrollImg17 = () => {
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");
      const scroll = window.scrollY + window.innerHeight / 3;

      let isActiveSectionFound = false;

      sections.forEach((section) => {
        const top = section.offsetTop;
        const height = section.offsetHeight;

        if (top <= scroll && top + height > scroll) {
          sections.forEach((s) => s.classList.remove("active"));
          section.classList.add("active");
          isActiveSectionFound = true;
        }
      });

      // If no section is in view, ensure all are inactive
      if (!isActiveSectionFound) {
        sections.forEach((s) => s.classList.remove("active"));
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Trigger the scroll effect initially
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const images = [c1, c2, c3, c4, c5, c6, c7];


  return (
    <div>
      {images.map((image, index) => (
        <div key={index} className="section">
          <div className="section-img">
            <div
              className="section-img-inner"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScrollImg17;
